import api from '../../utils/helpers/api'

type ResponType = {
  data: any
  meta: object
}

const uriUpdateProfile = 'user/user_detail/update'
const uriEducation = '/user/user_education'
const uriEducationUploadCertificate = '/user/user_education/upload-certificate'
const uriEducationUploadTranscript = '/user/user_education/upload-transcript'
const uriSkilll = 'user/user_skill'
const uriSkillUpload = 'user/user_skill/upload-file'
const uriLanguage = 'user/user_language'
const uriLanguageUpload = 'user/user_language/upload-file'
const uriExperience = 'user/user_experience'
const uriExperienceUpload = 'user/user_experience/upload-file'
const uriOther = 'user/user_other'
const uriOtherUpload = 'user/user_other/upload-file'
const uriAddress = 'user/user_address'
const dashboardAlumni = 'dashboard/alumni'
const dashboardAdmin = 'dashboard/admin'
const dashboardCompany = 'dashboard/company'
const downloadResume = 'user/generate-cv'
const uploadPhotoProfile = 'user/user_detail/upload-image'
const uriReportALumni = 'dashboard/report-alumni'
const uriPdfReportALumni = 'dashboard/report-alumni-pdf'
const uriExcelReportALumni = 'dashboard/report-alumni-excel'

const user = {
  uploadPhotoProfile: async (data: any) => {
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
      formData.append('_method', 'PATCH')
    }
    return (await api.post(`${uploadPhotoProfile}`, formData)) as Promise<ResponType>
  },
  dashboardAlumni: async () => {
    return (await api.get(dashboardAlumni)) as Promise<ResponType>
  },

  dashboardAdmin: async () => {
    return (await api.get(dashboardAdmin)) as Promise<ResponType>
  },

  dashboardCompany: async () => {
    return (await api.get(dashboardCompany)) as Promise<ResponType>
  },

  getProfile: async () => {
    try {
      const data: any = await api.get(`profile`)
      return data.data
    } catch (error) {
      throw error
    }
  },
  updateProfile: async (data: any) => {
    return (await api.put(uriUpdateProfile, data)) as Promise<ResponType>
  },
  createOrUpdateSkill: async (data: any, id?: number) => {
    let uri
    if (id) {
      uri = uriSkilll + '/' + id
    }
    return (await api[id ? 'put' : 'post'](id ? uri : uriSkilll, data)) as Promise<ResponType>
  },
  uploadFileSkill: async (data: any, id: any) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
      formData.append('_method', 'PATCH')
    }
    return (await api.post(`${uriSkillUpload}/${id}`, formData)) as Promise<ResponType>
  },
  deleteSkill: async (id: number) => {
    return (await api.delete(`${uriSkilll}/${id}`)) as Promise<ResponType>
  },
  createOrUpdateLanguage: async (data: any, id?: any) => {
    let uri
    if (id) {
      uri = uriLanguage + '/' + id
    }
    return (await api[id ? 'put' : 'post'](id ? uri : uriLanguage, data)) as Promise<ResponType>
  },
  uploadFileLanguage: async (data: any, id: any) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
      formData.append('_method', 'PATCH')
    }
    return (await api.post(`${uriLanguageUpload}/${id}`, formData)) as Promise<ResponType>
  },
  deleteLanguage: async (id: number) => {
    return (await api.delete(`${uriLanguage}/${id}`)) as Promise<ResponType>
  },
  createOrUpdateExperience: async (data: any, id?: number) => {
    let uri
    if (id) {
      uri = uriExperience + '/' + id
    }
    return (await api[id ? 'put' : 'post'](id ? uri : uriExperience, data)) as Promise<ResponType>
  },
  uploadFileExperience: async (data: any, id: any) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
      formData.append('_method', 'PATCH')
    }
    return (await api.post(`${uriExperienceUpload}/${id}`, formData)) as Promise<ResponType>
  },
  deleteExperience: async (id: number) => {
    return (await api.delete(`${uriExperience}/${id}`)) as Promise<ResponType>
  },
  createOrUpdateEducation: async (data: any, id?: any) => {
    let uri
    if (id) {
      uri = uriEducation + '/' + id
    }
    return (await api[id ? 'put' : 'post'](id ? uri : uriEducation, data)) as Promise<ResponType>
  },
  uploadFileEducationCertificate: async (data: any, id: any) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
      formData.append('_method', 'PATCH')
    }
    return (await api.post(
      `${uriEducationUploadCertificate}/${id}`,
      formData
    )) as Promise<ResponType>
  },
  uploadFileEducationTranscript: async (data: any, id: any) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
      formData.append('_method', 'PATCH')
    }
    return (await api.post(
      `${uriEducationUploadTranscript}/${id}`,
      formData
    )) as Promise<ResponType>
  },
  showEducation: async (id: any) => {
    return (await api.get(`${uriEducation}/${id}`)) as Promise<ResponType>
  },
  deleteEducation: async (id: any) => {
    return (await api.delete(`${uriEducation}/${id}`)) as Promise<ResponType>
  },
  createOrUpdateOther: async (data: any, id?: number) => {
    let uri
    if (id) {
      uri = uriOther + '/' + id
    }
    return (await api[id ? 'put' : 'post'](`${id ? uri : uriOther}`, data)) as Promise<ResponType>
  },
  uploadFileOther: async (data: any, id: any) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
      formData.append('_method', 'PATCH')
    }
    return (await api.post(`${uriOtherUpload}/${id}`, formData)) as Promise<ResponType>
  },
  deleteOther: async (id: number) => {
    return (await api.delete(`${uriOther}/${id}`)) as Promise<ResponType>
  },
  createOrUpdateAddress: async (data: any, id: any) => {
    let uri
    if (id) {
      uri = uriAddress + '/' + id
    }
    return (await api[id ? 'put' : 'post'](id ? uri : uriAddress, data)) as Promise<ResponType>
  },
  downloadResume: async (id: any) => {
    return await api.get(`${downloadResume}/${id}`)
  },
  reportAlumni: async (params: any) => {
    return (await api.get(uriReportALumni, {params})) as Promise<ResponType>
  },
  pdfReportAlumni: async (params: any) => {
    return (await api.get(uriPdfReportALumni, {params})) as Promise<ResponType>
  },
  excelReportAlumni: async (params: any) => {
    return (await api.get(uriExcelReportALumni, {params})) as Promise<ResponType>
  },
}

export default user
